import {
  FormControl,
  SelectProps,
  FormHelperText,
  FormErrorMessage,
} from '@chakra-ui/react'
import React from 'react'
import { FormLabel } from './FormLabel'
import { Select } from './Select'

interface LabeledSelectProps extends SelectProps {
  label: string
  size?: 'sm' | 'md'
  helperText?: string
  errorMessage?: string
}

export const LabeledSelect = ({
  children,
  isRequired,
  label,
  isInvalid,
  helperText,
  errorMessage,
  isDisabled,
  isReadOnly,
  size = 'md',
  ...baseProps
}: LabeledSelectProps) => (
  <FormControl
    isRequired={isRequired}
    isInvalid={isInvalid}
    isDisabled={isDisabled}
    isReadOnly={isReadOnly}
  >
    <FormLabel
      fontWeight={isRequired ? 'semibold' : 'regular'}
      color={isInvalid ? 'red.500' : 'black'}
    >
      {label}
    </FormLabel>
    <Select size={size} isInvalid={isInvalid} {...baseProps}>
      {children}
    </Select>
    {helperText && <FormHelperText>{helperText}</FormHelperText>}
    {errorMessage && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
  </FormControl>
)
